// extracted by css-extract-rspack-plugin
export default {"root":"KNHBd","card":"OBO3l","label":"ES1SC","description":"I5zqi","cardTitle":"nUgFL"};